import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Panel from './Panel';

function RequestType({ formMode, lookingFor, useUpdateParamWithEvent }) {
  const onLookingForChanged = useUpdateParamWithEvent('lookingFor');
  const isEditMode = formMode === 'edit';

  return (
    <div>
      {!isEditMode && (
        <Panel>
          <div className="row">
            <div className="col-12 col-sm-6 align-self-">
              <label
                aria-label="Find a person"
                htmlFor="lookingForPerson"
                className={classNames('card d-flex flex-row h-100 p-3 new-request-type-card', {
                  'border-primary': lookingFor === 'person',
                })}
              >
                <div>
                  <input
                    checked={lookingFor === 'person'}
                    className="me-2 form-check-input"
                    id="lookingForPerson"
                    name="lookingFor"
                    onChange={onLookingForChanged}
                    type="radio"
                    value="person"
                  />
                </div>
                <div>
                  <h3 className="mb-1" style={{ fontSize: '18px', fontWeight: 600 }}>
                    <i className="fa fa-user-magnifying-glass pe-1" />
                    Find a person
                  </h3>
                  <span className="text-secondary" style={{ fontSize: '16px' }}>
                    A person to provide expertise, comments, opinions, or advice.
                  </span>
                </div>
              </label>
            </div>

            <div className="col-12 col-sm-6 mt-4 mt-sm-0 align-self-stretch">
              <label
                aria-label="Find a product"
                htmlFor="lookingForProduct"
                className={classNames('card d-flex flex-row h-100 p-3 col-12 col-xs-6 new-request-type-card', {
                  'border-primary': lookingFor === 'product',
                })}
              >
                <div>
                  <input
                    checked={lookingFor === 'product'}
                    className="me-2 form-check-input"
                    id="lookingForProduct"
                    name="lookingFor"
                    onChange={onLookingForChanged}
                    type="radio"
                    value="product"
                  />
                </div>
                <div>
                  <h3 className="mb-1" style={{ fontSize: '18px', fontWeight: 600 }}>
                    <i className="fa fa-gift pe-1" />
                    Find a product
                  </h3>
                  <span className="text-secondary" style={{ fontSize: '16px' }}>
                    A product to be recommended, highlighted, or showcased.
                  </span>
                </div>
              </label>
            </div>
          </div>
        </Panel>
      )}
    </div>
  );
}

RequestType.propTypes = {
  formMode: PropTypes.string,
  lookingFor: PropTypes.string,
  useUpdateParamWithEvent: PropTypes.func.isRequired,
};

RequestType.defaultProps = {
  formMode: 'create',
  lookingFor: 'person',
};

export default RequestType;
